/**
 * FreeOptionsTable container  selectors
 *
 * @author Diogo Guedes <dguedes@ubiwhere.com>
 *
 */
import { RootState } from 'store/rootSlices';

export const getIsolatedOptionsListSlice = (state: RootState) => state.IsolatedOptionsTable;
export const getUcs = (state: RootState) => state.Schedules.freeUcs;
export const getAppSlice = (state: RootState) => state.App;
